import {
  styled,
  Card,
  TextField,
  buttonClasses,
  textFieldClasses,
  inputBaseClasses,
  Button,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ActionsWidgetCardContainer = styled(Card)(({ theme }) => ({
  width: '100%',
  minWidth: 520,
  padding: theme.spacing(1.5, 2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  borderRadius: 12,
  backgroundColor: theme.palette.common.white,
  justifyContent: 'flex-start',
}));

export const ActionsWidgetCardFieldWithButtonGroup = styled('div')(
  ({ theme }) => ({
    display: 'inline-flex',
    borderRadius: theme.shape.borderRadius,
    width: '100%',

    [`& .${textFieldClasses.root} .${inputBaseClasses.root}`]: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRightColor: 'transparent',
    },

    [`& .${buttonClasses.root}`]: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginLeft: -1,
    },
  }),
);

export const ActionsWidgetCardTextField = styled(TextField)({
  [`& .${inputBaseClasses.root}`]: {
    height: 41,
  },
});

export const ActionsWidgetCardButton = styled(Button)(({ theme }) => ({
  height: 41,

  [`& .${buttonClasses.startIcon}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${buttonClasses.endIcon}`]: {
    marginLeft: theme.spacing(2),
  },
}));

export const ActionsWidgetCardIconButton = styled(ActionsWidgetCardButton)(
  ({ theme }) => ({
    minWidth: 41,
    padding: theme.spacing(0, 1.5),
  }),
);

export const ActionsWidgetCardIconButtonIcon = styled(FontAwesomeIcon)(
  ({ theme }) => ({
    fontSize: theme.typography.pxToRem(17),
  }),
);
